@if (schedulerService.branchSelected()){
  <div class="flex flex-col gap-8 pt-4">
    <div class="flex justify-end">
      <div class="w-[30%] md:w-1/6 lg:w-1/6">
        <afcu-input [form]="form" [question]="questions[0]" (externalFunction)="selectEvent($event)"/>
      </div>
    </div>
    <div class="font-bold text-3xl text-gray-900 w-full text-center">{{renderTemplate(greeting.title)}}</div>
    <div class="text-black">{{greeting.description}}</div>
    <div class="flex flex-col md:flex-row gap-4 md:gap-8 pb-2">
      @if(enableWalkin){
        <button
          class="bg-afcu-navy-800 px-6 py-3.5 text-white font-semibold w-full md:flex-1 cursor-pointer"
          [innerHTML]="getText()[target].button.walkin"
          (click)="gotTo(true)">
        </button>
      }
      @if(enableCheckin){
        <button
          class="bg-afcu-navy-800 px-6 py-3.5 text-white font-semibold w-full md:flex-1 cursor-pointer"
          [innerHTML]="getText()[target].button.checkin"
          (click)="gotTo(false)">
        </button>
      }
      
    </div>

    @if(enableBanner){
      <afcu-banner [content]="bannerContent" [state]="bannerContent.type!"/>
    }

  </div>  
} @else {
  <afcu-loading [target]="''" />
}